import {
  trigger,
  transition,
  style,
  animate,
  query,
} from '@angular/animations';

/**
 * Fade-in transition applied to the router-outlet on every route change.
 * The leaving page fades out while the entering page fades in.
 */
export const routeFadeAnimation = trigger('routeAnimation', [
  transition('* <=> *', [
    query(
      ':enter',
      [
        style({ opacity: 0, translate: '0 8px' }),
        animate(
          '220ms ease-out',
          style({ opacity: 1, translate: '0 0' }),
        ),
      ],
      { optional: true },
    ),
  ]),
]);
